export default {
  maxHeight: 800,
  sarchShow: true,
  searchMenuSpan: 24,
  calcHeight: 100,
  tip: false,
  border: true,
  index: true,
  viewBtn: false,
  selection: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  menu: true,
  menuWidth: 120,
  columnBtn: true,
  refreshBtn:true,
  stripe:true,
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      searchslot: true,
      width: 150,
      hide: true,
      props: {
        label: 'title',
        value: 'key',
      },
      searchSpan: 6,
    },
    {
      label: '车场名称',
      prop: 'spaceName',
    },
    {
      label: '区域名称',
      prop: 'regionName',
      span: 12,
    },
    {
      label: '车牌号',
      prop: 'carNo',
      width: 100,
      searchSpan: 6,
    },
    {
      label: '车牌颜色',
      prop: 'plateColorStr',
      width: 100,
      searchSpan: 6,
    },
    {
      label: '车辆分类',
      prop: 'carType',
    },
    {
      label: '入场时间',
      prop: 'dateRange',
      searchSpan: 12,
      hide: true,
      searchslot: true,
      searchRange: true,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      label: '入场时间',
      prop: 'inTime',
      width: 150,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      label: '在场时长',
      prop: 'parkingTime',
      width: 150,
      slot:true,
      headerslot:true,

    },
    {
      label: '入场备注',
      prop: 'inMemo',
      width: 150,
    },
    {
      label: '入场通道名称',
      prop: 'inPassageName',
    },
    {
      label: '操作类型',
      prop: 'parkEventType',
      disabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=parkEventType',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'string',
    },
  ],
};
